import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae21789e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg-white vh-100 d-flex flex-column"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notch" }, null, -1))
const _hoisted_3 = { class: "flex-grow-1 d-flex flex-column justify-content-end" }
const _hoisted_4 = {
  key: 0,
  class: "text-center m-3 p-2 small border"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "開発メニュー(prod, demoでは表示されません)", -1))
const _hoisted_6 = { class: "link-and-button-container" }
const _hoisted_7 = { class: "text-center mt-3 small" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "button-container" }
const _hoisted_11 = {
  key: 0,
  class: "skip-link-container"
}
const _hoisted_12 = {
  key: 1,
  class: "main-container"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notch" }, null, -1))
const _hoisted_14 = { class: "welcome-section" }
const _hoisted_15 = { class: "bottom-section" }
const _hoisted_16 = {
  key: 0,
  class: "text-center m-3 p-2 small border"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "開発メニュー(prod, demoでは表示されません)", -1))
const _hoisted_18 = { class: "link-and-button-container" }
const _hoisted_19 = { class: "text-center mt-3 small" }
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "button-container" }

import AppButton from "@/components/atoms/button/AppButton.vue";
import { VUE_APP_ENV } from "@/config/VueAppEnv";
import ExternalLink from "@/const/externalLink";
import { authStore } from "@/store/auth";
import { computed, onMounted } from "vue";
import { AbTest3113 } from "@/app/services/AbTestService";
import { sendAdjustEvent } from "@/plugins/adjust";
import { useCustomRouter } from "@/utils/router";
import { deviceModule } from "@/store/device";


export default /*#__PURE__*/_defineComponent({
  __name: 'Welcome',
  setup(__props) {

const { pushIgnoreError } = useCustomRouter();

const canSkipRegistration = computed(
  () => authStore.isCaitechPharmacistProduct && deviceModule.isIos
);
const productAssetSuffix = computed(() => authStore.productAssetSuffix);
const ruleLink = computed(() =>
  authStore.isCaitechPharmacistProduct
    ? ExternalLink.RULE_CAITECH_PHARMACIST
    : ExternalLink.RULE
);
const privacyLink = computed(() => ExternalLink.PRIVACY);
const registerOrLoginRoute = computed(() => ({ name: "RegisterOrLogin" }));
const isDevMenuVisible = computed(() => {
  const env = VUE_APP_ENV;
  return !(env === "prod" || env === "demo");
});
const testGroup = computed(() => AbTest3113.getTestGroup());
const isAbTest3113GroupAorB = computed(() =>
  ["A", "B"].includes(testGroup.value)
);
const backgroundClass = computed(() =>
  !isAbTest3113GroupAorB.value && testGroup.value
    ? `background-without-text-${testGroup.value.toLowerCase()}`
    : null
);

onMounted(() => {
  AbTest3113.registerEvent(AbTest3113.eventTypes.entry);
});

function moveToSearch() {
  sendAdjustEvent("SKIP_REGISTRATION");
  pushIgnoreError({ name: "Search" });
}

function changeProduct(productSlug: string) {
  authStore.changeProduct(productSlug);
  location.reload();
}

return (_ctx: any,_cache: any) => {
  return (isAbTest3113GroupAorB.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", {
          class: _normalizeClass(["pt-3 mb-4 d-flex align-items-center justify-content-center", `background-without-text${productAssetSuffix.value}`])
        }, null, 2),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
          (isDevMenuVisible.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createTextVNode(),
                _createVNode(AppButton, {
                  block: "",
                  size: "sm",
                  variant: "mild",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (changeProduct('caitech_care')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("\n          「カイテク（介護・看護）」アプリに変更\n        ")
                  ], undefined, true),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(AppButton, {
                  block: "",
                  size: "sm",
                  variant: "mild",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (changeProduct('caitech_pharmacist')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("\n          「カイテク薬剤師」アプリに変更\n        ")
                  ], undefined, true),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _createElementVNode("a", {
                href: ruleLink.value,
                class: "text-primary"
              }, "利用規約", 8, _hoisted_8),
              _createTextVNode("と"),
              _createElementVNode("a", {
                href: privacyLink.value,
                class: "text-primary"
              }, "プライバシーポリシー", 8, _hoisted_9),
              _createTextVNode("に同意して\n        ")
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(AppButton, {
                block: "",
                class: _normalizeClass(["rounded start-button", { 'with-skip-link': canSkipRegistration.value }]),
                to: registerOrLoginRoute.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n            はじめる\n          ")
                ], undefined, true),
                _: 1
              }, 8, ["class", "to"]),
              _createTextVNode(),
              (canSkipRegistration.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("u", {
                      class: "text-size-14 text-mild",
                      onClick: moveToSearch
                    }, "\n              スキップしてお仕事を見てみる\n            ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
        _hoisted_13,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(["background-image", backgroundClass.value])
          }, null, 2)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_15, [
          (isDevMenuVisible.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                _createTextVNode(),
                _createVNode(AppButton, {
                  block: "",
                  size: "sm",
                  variant: "mild",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (changeProduct('caitech_care')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("\n          「カイテク（介護・看護）」アプリに変更\n        ")
                  ], undefined, true),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(AppButton, {
                  block: "",
                  size: "sm",
                  variant: "mild",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (changeProduct('caitech_pharmacist')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("\n          「カイテク薬剤師」アプリに変更\n        ")
                  ], undefined, true),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, [
              _createElementVNode("a", {
                href: ruleLink.value,
                class: "text-primary"
              }, "利用規約", 8, _hoisted_20),
              _createTextVNode("と"),
              _createElementVNode("a", {
                href: privacyLink.value,
                class: "text-primary"
              }, "プライバシーポリシー", 8, _hoisted_21),
              _createTextVNode("に同意して\n        ")
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(AppButton, {
                block: "",
                class: "rounded start-button",
                to: registerOrLoginRoute.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n            はじめる\n          ")
                ], undefined, true),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ]))
}
}

})